import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { BookServiceService } from "src/app/services/book-service.service";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-add-book",
  templateUrl: "./add-book.component.html",
  styleUrls: ["./add-book.component.scss"]
})
export class AddBookComponent implements OnInit {
  constructor(private bookSer: BookServiceService, private router: Router) {}
  validatingForm: FormGroup;
  isLoading = false;

  ngOnInit() {
    this.validatingForm = new FormGroup({
      title: new FormControl("", Validators.required),
      description: new FormControl("", [
        Validators.required,
        Validators.minLength(10)
      ]),
      image: new FormControl("", [
        Validators.required,
        Validators.minLength(10)
      ]),
      rate: new FormControl("", [Validators.required, Validators.max(5)])
    });
  }

  on(form: any) {
    this.isLoading = true;
    const v = form.value;
    const title = v.title;
    const description = v.description;
    const image = v.image;
    const rate = v.rate;
    this.bookSer
      .AddBook({ title, description, image, rate })
      .catch(err => err)
      .then(() => {
        this.isLoading = true;
        form.reset();
      })
      .finally(() => {
        this.isLoading = false;
        this.router.navigate(["/admin"]);
      });
    this.isLoading = false;
  }
}
